export default class DBEntity {
  #name;

  constructor(name) {
    this.#name = name.replaceAll(' ', '_');
  }

  setName(name) {
    this.#name = name.replaceAll(' ', '_');
  }

  getName() {
    return this.#name;
  }
}
